<template>
  <div>
    <div
      class="instruction_title text-left para-mrgn-20"
      v-translate:dynamic_string="{
        key: `${translationKeyInitial}_formattedTitle`,
        val: lang,
        html: question.formattedTitle
      }"
      v-html="question.formattedTitle"
    ></div>
    <div v-if="question.imageUrl" @click.once="$emit('onClick', question)" class="imageBox text-center">
      <img width="100%" class="img-size" :src="question.imageUrl" alt="" />
    </div>
    <div
      class="instruction_info text-justify mt-5 pt-5"
      v-translate:dynamic_string="{
        key: `${translationKeyInitial}_formattedInformation`,
        val: lang,
        html: question.formattedInformation
      }"
      v-html="question.formattedInformation"
    ></div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import { loadData } from "@/services/video-render";
export default {
  name: "instruction",
  mixins: [langTranslate],
  mounted() {
    loadData(this.$el);
  },
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"]
};
</script>
